var _path, _path2, _g, _path3, _g2, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 85,
    viewBox: "0 0 84 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_157_4554",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 84,
    height: 85
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.675781 0.890625H83.9987V84.2135H0.675781V0.890625Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_157_4554)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_157_4554",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 84,
    height: 85
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3372 0.890625C19.332 0.890625 0.675781 19.5417 0.675781 42.5521C0.675781 65.5625 19.332 84.2135 42.3372 84.2135C65.3477 84.2135 83.9987 65.5625 83.9987 42.5521C83.9987 19.5417 65.3477 0.890625 42.3372 0.890625Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_157_4554)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.675781 0.890625H83.9987V84.2135H0.675781V0.890625Z",
    fill: "#52539F"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_157_4554",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 22,
    width: 41,
    height: 41
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.207 22.416H62.207V62.416H22.207V22.416Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_157_4554)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.2279 22.416H27.4466C24.556 22.416 22.207 24.7702 22.207 27.6608V57.4421C22.207 60.3327 24.556 62.6816 27.4466 62.6816H57.2279C60.1185 62.6816 62.4727 60.3327 62.4727 57.4421V27.6608C62.4727 24.7702 60.1185 22.416 57.2279 22.416ZM58.7904 27.916V57.1868C58.7904 57.4264 58.7435 57.6608 58.6497 57.8796C58.5612 58.1035 58.4258 58.3014 58.2591 58.4733C58.0872 58.64 57.8893 58.7702 57.6706 58.8639C57.4466 58.9577 57.2174 59.0046 56.9727 59.0046H27.7018C27.4622 59.0046 27.2279 58.9577 27.0091 58.8639C26.7852 58.7702 26.5872 58.64 26.4206 58.4733C26.2487 58.3014 26.1185 58.1035 26.0247 57.8796C25.931 57.6608 25.8841 57.4264 25.8841 57.1868V27.916C25.8841 27.6712 25.931 27.4421 26.0247 27.2181C26.1185 26.9993 26.2487 26.8014 26.4206 26.6296C26.5872 26.4629 26.7852 26.3275 27.0091 26.2389C27.2279 26.1452 27.4622 26.0983 27.7018 26.0983H56.9727C57.2174 26.0983 57.4466 26.1452 57.6706 26.2389C57.8893 26.3275 58.0872 26.4629 58.2591 26.6296C58.4258 26.8014 58.5612 26.9993 58.6497 27.2181C58.7435 27.4421 58.7904 27.6712 58.7904 27.916Z",
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5924 37.0215H34.5716C34.7279 37.0215 34.8633 37.0788 34.9727 37.1882C35.0872 37.3027 35.1393 37.4382 35.1393 37.5944V53.9746C35.1393 54.1309 35.0872 54.2663 34.9727 54.3809C34.8633 54.4902 34.7279 54.5475 34.5716 54.5475H31.5924C31.4362 54.5475 31.3008 54.4902 31.1862 54.3809C31.0768 54.2663 31.0195 54.1309 31.0195 53.9746V37.5944C31.0195 37.4382 31.0768 37.3027 31.1862 37.1882C31.3008 37.0788 31.4362 37.0215 31.5924 37.0215Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4857 32.9785C35.4805 31.5775 34.4701 30.5566 33.0846 30.5566C31.6992 30.5566 30.6523 31.6035 30.6523 32.9889C30.6523 33.6348 30.8867 34.2337 31.3138 34.6816C31.7513 35.1348 32.3607 35.39 33.0169 35.39C33.7461 35.39 34.3971 35.1296 34.8503 34.6608C35.2773 34.2233 35.5013 33.6296 35.4857 32.9889C35.4857 32.9889 35.4857 32.9837 35.4857 32.9785Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7957 38.1712C50.3113 36.8483 48.5717 36.6504 47.6707 36.6504C46.3165 36.6504 45.0301 37.0098 43.9467 37.6921C43.4728 37.9941 43.0457 38.3431 42.6603 38.7546L42.5874 37.5566C42.5769 37.4056 42.5144 37.2754 42.4051 37.1764C42.2957 37.0723 42.1655 37.0202 42.0144 37.0202H39.379C39.2124 37.0202 39.0717 37.0827 38.9571 37.2025C38.8426 37.3223 38.7957 37.4681 38.8061 37.6348C38.8998 38.8848 38.9415 40.1973 38.9415 42.0254V53.9733C38.9415 54.1296 38.9988 54.265 39.1082 54.3796C39.2176 54.4889 39.353 54.5462 39.5144 54.5462H42.4884C42.6498 54.5462 42.7853 54.4889 42.8946 54.3796C43.004 54.265 43.0613 54.1296 43.0613 53.9733V44.1243C43.0613 43.6608 43.1238 43.2285 43.228 42.9316C43.2332 42.9212 43.2384 42.916 43.2384 42.9056C43.6446 41.5879 44.8634 40.2598 46.6863 40.2598C47.8165 40.2598 48.6238 40.6452 49.1655 41.4421C49.6499 42.1556 49.9051 43.2285 49.9051 44.5306V53.9733C49.9051 54.1296 49.9623 54.265 50.0717 54.3796C50.1863 54.4889 50.3217 54.5462 50.478 54.5462H53.4571C53.6134 54.5462 53.7488 54.4889 53.8582 54.3796C53.9728 54.265 54.0249 54.1296 54.0249 53.9733V44.1921C54.0249 42.7962 53.8165 41.5618 53.3999 40.5202C53.0301 39.5827 52.4884 38.7962 51.7957 38.1712Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnLinkedin);
export default __webpack_public_path__ + "static/media/icn_linkedin.27e86ea7f614436389c457f290af8f03.svg";
export { ForwardRef as ReactComponent };